<template lang="pug">
.supporter.row.ac
    //h2.font-16.bp.cw(style="margin-right:20px;padding:20px;opacity:.8;border-radius:8px") TÉCNICO
    .row.js.ae.g11(v-if="sup.id")
        .col
            label ID
            b {{sup.id}} 
        .col
            label CNPJ
            b {{sup.cnpj | cnpj }} 
        .col 
            label NOME 
            b {{sup.nome}} 
        .col
            label E-mail
            b {{sup.email}}
        .col
            button.r.fa.fa-times.font-25.fb(@click="sup={};cb(false)" title="CANCELAR")
    form.row.js.wp.ae.g11(v-if="!sup.id && !list.length" onsubmit="return false" @submit="search")
        .col.g12-s
            label NOME
            input(v-model="filter.nome" placeholder="Nome")
        .col.g12-s
            label E-MAIL
            input(v-model="filter.email" placeholder="E-mail")
        .col.g12-s
            label CPF
            input(v-model="filter.cpf" placeholder="CPF")
        .col.g12-s
            label CNPJ
            input(v-model="filter.cnpj" placeholder="CNPJ")
        button.bt.p(type="submit")
            Loader(v-if="loader" layout="mini white")
            | Buscar
    .list(v-if="list.length")
        .sup.row(v-for="s in list" @click="sup=s;cb(s);list=[]" :key="'sup'+s.id")
            b {{s.id}} {{s.nome}} {{s.cnpj | cnpj }}

</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
export default {
    name: "Supporter",
    components: { Button, Loader },
    props: ["cb"],
    data() {
        return {
            sup: {},
            list: [],
            open: false,
            loader: false,
            filter: { nome: "", email: "", cpf: "", cnpj: "" }
        };
    },
    methods: {
        ...mapActions("admin", ["SUPPORTERS_LIST"]),
        ...mapMutations("general", ["SET_STATUS"]),
        async search() {
            this.loader = true
            this.list = []
            let { data } = await this.SUPPORTERS_LIST(this.filter)
            if (data) this.list = data
            else this.SET_STATUS({ text: "Nenhum supporter encontrado", color: "orange"  });
            this.loader = false
        },
    },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporter
    padding: 20px 10px
    label
        @include label
    .r
        background: none
        margin-right:20px
        &:hover
            color: $red
    .list
        z-index: 999
        //margin-top: 120px
        width: 80%
        max-height: 300px
        overflow: auto
        /* position: absolute */
        background: white
        @include border
        border-radius: 12px
        color: $font-color
        .sup
            padding: 20px 10px
            &:hover
                background: $purple
                color: white
                cursor: pointer       

</style>